<template>
  <section class="quotes-container">
    <!-- Show All Quotes -->
    <ul class="table-header">
      <li class="table-column title">Customer</li>
      <li class="table-column source">Source</li>
      <li class="table-column rep">
        <p>Sales Rep</p>
        <template v-if="showRepsFilter">
          <button class="btn" @click="$emit('toggleShowRepsFilter')">
            <img src="@/assets/icons/ui/filter.png" alt="filter by rep icon" />
          </button>

          <div class="reps-filter" :class="{ active: showRepsDropdownFilter }">
            <label for="any-rep">
              <input
                type="checkbox"
                id="any-rep"
                name="any-rep"
                @input="!filterByAllReps && $emit('filterByAllReps')"
                :checked="filterByAllReps"
              />
              <span>Any</span>
            </label>
            <label
              v-for="rep in dealer.reps"
              :for="rep.id + '-rep'"
              :key="rep.id + '-rep'"
            >
              <input
                type="checkbox"
                :id="rep.id + '-rep'"
                :name="rep.id + '-rep'"
                :key="rep.id + '-rep'"
                :value="Number(rep.id)"
                @input="$emit('filterByRep', rep)"
                :checked="repsToFilter.includes(Number(rep.id))"
              />
              <span>{{ rep.name }}</span>
            </label>
          </div>
        </template>
      </li>
      <li class="table-column date">Date Requested</li>
      <li class="table-column quote">Quote #</li>
    </ul>

    <ul class="table-content-container">
      <MyQuotesRow
        v-for="(quote, i) in quotes"
        :key="i + '-quote-' + quote.type"
        :quote="quote"
        :showLink="showLink"
        :typeOfProject="quote && quote.project && quote.project.type"
      />
    </ul>

    <section class="team-links-container row">
      <!-- No quotes found by filters -->
      <article v-if="!quotes.length" class="team-link col text-center">
        <h3>No Quotes Found</h3>
      </article>
    </section>
  </section>
</template>

<script>
import MyQuotesRow from "@/components/Dashboard/Messages/MyQuotesRow.vue";
import { mapState } from "vuex";
export default {
  name: "MyQuotesTable",
  components: {
    MyQuotesRow,
  },
  props: [
    "quotes",
    "filterByAllReps",
    "repsToFilter",
    "showRepsFilter",
    "showRepsDropdownFilter",
    "showLink",
  ],

  computed: {
    ...mapState(["dealer"]),
  },
};
</script>

<style lang="scss" scoped>
.quotes-container {
  ul,
  ::v-deep ul {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    list-style: none;
    width: 100%;
    margin-bottom: 0;
    li {
      p,
      span,
      a {
        text-transform: capitalize;
      }

      &.title {
        width: 25%;
        text-transform: capitalize;
        a {
          color: $dark;
          &:hover {
            color: $blue;
            text-decoration: underline !important;
          }
        }
      }
      &.source {
        width: 20%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        span.slate-light {
          color: $grey-dark;
        }
      }
      &.date {
        width: 15%;
      }
      &.rep {
        width: 15%;
      }
      &.quote {
        width: 10%;
      }
      &.link {
        width: 15%;
        a {
          background-color: $grey-light;
          color: $dark;
          border-radius: 8px;
          transition: background-color 0.2s ease-in-out;
          &:hover {
            background-color: $dark;
            color: white;
          }
        }
      }
    }
  }

  .table-header,
  ::v-deep .table-header {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
    padding: 0 1.25rem;
    li {
      color: $grey-dark;
    }
  }

  .table-column,
  ::v-deep .table-column {
    display: flex;
    align-items: center;
    text-transform: capitalize;
    /* width: 25%; */

    &.rep {
      position: relative;
      p {
        color: $grey-dark;
      }

      .reps-filter {
        justify-content: center;
        background: white;
        border-radius: 6px;
        box-shadow: 0px 9px 18px rgba(40, 42, 48, 0.2);
        display: flex;
        flex-direction: column;
        padding: 1rem;
        position: absolute;
        top: 3rem;
        left: -25%;
        width: 100%;
        z-index: 10;
        opacity: 0;
        transition: all 0.1s ease-in-out;
        visibility: hidden;
        &.active {
          opacity: 1;
          visibility: visible;
        }
        label {
          display: flex;
          align-items: center;
          margin-bottom: 0.5rem;
          input {
            margin-right: 0.75rem;
          }
        }
      }
    }
  }

  .table-content-container {
    li.table-item {
      width: 100%;
      padding: 1.25rem;
      background: white;
      border-bottom: 1px solid $dark;
      li.table-column {
        img {
          margin-right: 0.5rem;
        }
      }
    }
  }
}
</style>